import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 767px) {
    // margin-bottom: 50px;
  }
`;

export const Title = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  text-transform: capitalize;
  color: #000000;
`;

export const Container = styled.div`
  text-align: center;
  margin: 100px 0;
  padding-top: 100px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    margin: 50px 0;
  }
`;

export const LogosWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 50px;

  @media screen and (max-width: 767px) {
    max-width: 100%;
    margin-top: 30px;
    display: block;
  }
`;

export const LogoMobileRow = styled.div`
  flex-grow: 1;
  justify-content: space-around;
  align-items: center;
  display: flex;

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 20px;
  }
`;

export const Logo = styled.img`
  @media screen and (max-width: 767px) {
    max-width: 60%;
  }
`;
